import {
  SEGMENT_FIELD_TYPES,
  SEGMENT_TYPES,
  URL_MAX_LENGTH,
  IMAGE_POSITION_OPTIONS,
  HIGHLIGHT_ICON_OPTIONS,
  field,
  visualStyleProperty,
  appearanceProperties,
  commonSegment
} from "./segmentRegistryCore";

const contentSegments = {
  [SEGMENT_TYPES.ABOUT]: commonSegment({
    id: SEGMENT_TYPES.ABOUT,
    visibilityPath: "sections.showAbout",
    properties: [
      field("sections.showAbout", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar sección",
      }),
      field("about.eyebrow", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto superior",
        maxLength: 180,
      }),
      field("about.title", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título",
        maxLength: 220,
      }),
      field("about.description", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Historia o descripción",
        maxLength: 2500,
      }),
      field("about.imageUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Imagen del negocio",
        maxLength: URL_MAX_LENGTH,
      }),
      field("about.imageAlt", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto alternativo de la imagen",
        maxLength: 220,
      }),
      field("about.layout", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Distribución",
        options: [
          { value: "image-left", label: "Imagen a la izquierda" },
          { value: "image-right", label: "Imagen a la derecha" },
        ],
      }),
      field("about.imagePosition", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Posición de la imagen",
        options: IMAGE_POSITION_OPTIONS,
      }),
      field("about.ctaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto del botón",
        maxLength: 100,
      }),
      field("about.ctaUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino del botón",
        maxLength: URL_MAX_LENGTH,
        destinationPicker: true,
      }),
      field("about.ctaRequiresProducts", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "El botón requiere catálogo",
      }),
      ...appearanceProperties(SEGMENT_TYPES.ABOUT),
      visualStyleProperty(SEGMENT_TYPES.ABOUT),
    ],
  }),
  [SEGMENT_TYPES.HIGHLIGHTS]: commonSegment({
    id: SEGMENT_TYPES.HIGHLIGHTS,
    visibilityPath: "sections.showHighlights",
    properties: [
      field("sections.showHighlights", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar diferenciales",
      }),
      field("highlightsIntro.eyebrow", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Texto superior",
        maxLength: 180,
      }),
      field("highlightsIntro.title", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título",
        maxLength: 220,
      }),
      field("highlightsIntro.subtitle", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Descripción",
        maxLength: 900,
      }),
      field("highlights", SEGMENT_FIELD_TYPES.COLLECTION, {
        label: "Diferenciales",
        limits: { maxItems: 24 },
        item: {
          fields: [
            { key: "id", type: SEGMENT_FIELD_TYPES.TEXT, maxLength: 100 },
            { key: "icon", type: SEGMENT_FIELD_TYPES.SELECT, maxLength: 50, options: HIGHLIGHT_ICON_OPTIONS },
            { key: "title", type: SEGMENT_FIELD_TYPES.TEXT, maxLength: 160 },
            { key: "description", type: SEGMENT_FIELD_TYPES.TEXTAREA, maxLength: 600 },
            { key: "imageUrl", label: "Imagen de la tarjeta", type: SEGMENT_FIELD_TYPES.IMAGE, maxLength: URL_MAX_LENGTH },
            { key: "imageAlt", type: SEGMENT_FIELD_TYPES.TEXT, maxLength: 220 },
            { key: "imagePosition", label: "Posición de la imagen", type: SEGMENT_FIELD_TYPES.SELECT, options: IMAGE_POSITION_OPTIONS },
            { key: "youtubeUrl", label: "Video de YouTube", type: SEGMENT_FIELD_TYPES.URL, maxLength: URL_MAX_LENGTH },
          ],
        },
      }),
      field("appearance.highlights.backgroundImageUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Foto de fondo opcional",
        maxLength: URL_MAX_LENGTH,
        positionPath: "appearance.highlights.backgroundImagePosition",
      }),
      field("appearance.highlights.backgroundImagePosition", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Posición de la foto de fondo",
        options: IMAGE_POSITION_OPTIONS,
      }),
      field("appearance.highlights.backgroundImageOpacity", SEGMENT_FIELD_TYPES.NUMBER, {
        label: "Intensidad de la foto de fondo",
        min: 0,
        max: 1,
        step: 0.05,
        defaultValue: 0.24,
      }),
      ...appearanceProperties(SEGMENT_TYPES.HIGHLIGHTS),
      visualStyleProperty(SEGMENT_TYPES.HIGHLIGHTS),
    ],
  }),
  [SEGMENT_TYPES.CONTACT]: commonSegment({
    id: SEGMENT_TYPES.CONTACT,
    visibilityPath: "sections.showContact",
    properties: [
      field("sections.showContact", SEGMENT_FIELD_TYPES.BOOLEAN, {
        label: "Mostrar contacto",
      }),
      field("contact.title", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título",
        maxLength: 220,
      }),
      field("contact.subtitle", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Texto de apoyo",
        maxLength: 900,
      }),
      field("contact.whatsappMessage", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Mensaje inicial de WhatsApp",
        maxLength: 500,
      }),
      field("contact.backgroundImageUrl", SEGMENT_FIELD_TYPES.IMAGE, {
        label: "Imagen de fondo",
        maxLength: URL_MAX_LENGTH,
      }),
      field("contact.backgroundImagePosition", SEGMENT_FIELD_TYPES.SELECT, {
        label: "Posición de la imagen",
        options: IMAGE_POSITION_OPTIONS,
      }),
      field("contact.detailsCtaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Botón de detalles",
        maxLength: 100,
      }),
      field("contact.detailsCtaUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Destino del botón de detalles",
        maxLength: URL_MAX_LENGTH,
        destinationPicker: true,
      }),
      field("contact.whatsappCtaLabel", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Botón de WhatsApp",
        maxLength: 100,
      }),
      field("contact.mapTitle", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Título del mapa",
        maxLength: 180,
      }),
      field("business.whatsapp", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Número de WhatsApp",
        maxLength: 40,
        shared: true,
      }),
      field("business.phone", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Teléfono",
        maxLength: 80,
        shared: true,
      }),
      field("business.email", SEGMENT_FIELD_TYPES.EMAIL, {
        label: "Correo electrónico",
        maxLength: 180,
        shared: true,
      }),
      field("business.address", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Dirección",
        maxLength: 260,
        shared: true,
      }),
      field("business.city", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Ciudad",
        maxLength: 120,
        shared: true,
      }),
      field("business.province", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Provincia",
        maxLength: 120,
        shared: true,
      }),
      field("business.country", SEGMENT_FIELD_TYPES.TEXT, {
        label: "País",
        maxLength: 120,
        shared: true,
      }),
      field("business.schedule", SEGMENT_FIELD_TYPES.TEXTAREA, {
        label: "Horarios",
        maxLength: 400,
        shared: true,
      }),
      field("business.mapEmbedUrl", SEGMENT_FIELD_TYPES.URL, {
        label: "Mapa embebido",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      field("business.socials.instagram", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Instagram",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      field("business.socials.facebook", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Facebook",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      field("business.socials.linkedin", SEGMENT_FIELD_TYPES.TEXT, {
        label: "LinkedIn",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      field("business.socials.website", SEGMENT_FIELD_TYPES.TEXT, {
        label: "Sitio externo",
        maxLength: URL_MAX_LENGTH,
        shared: true,
      }),
      ...appearanceProperties(SEGMENT_TYPES.CONTACT),
      visualStyleProperty(SEGMENT_TYPES.CONTACT),
    ],
  }),
};

export default contentSegments;
